// @ts-check
import { Trans } from '@lingui/macro';
import Layout from '../../components/Layout/Layout';
import {
  PageHeader,
  PageSubtitle,
  PageTitle,
} from '../../components/Layout/PageHeader';

/**
 * Renders the imports select
 */
export default function NotFound() {
  return (
    <Layout>
      <PageHeader>
        <PageTitle>
          <Trans>Not found</Trans>
        </PageTitle>
        <PageSubtitle>
          <Trans>We couldn't find that page.</Trans>
        </PageSubtitle>
      </PageHeader>
    </Layout>
  );
}
